import React from 'react';
import PropTypes from 'prop-types';
import { GetFormRow, GetBrText } from '../utilities';

const ConfirmTable = (
  {
    form,
    confirmDisplay,
    inputBack,
    sendContact,
    token,
    form_settings
  }
) => {
  if (!confirmDisplay) {
    return null;
  }
  return (
    <div>
      <p className="contact-message">{GetBrText(form_settings.form_text.contact_message)}</p>
      <table className="table-forms">
        {form_settings.fields.map(field => {
          return GetFormRow(field, form, null, form_settings, false);
        })}
      </table>
      <p className="text-center">{GetBrText(form_settings.form_text.confirm_message)}</p>
      <div className="button-forms">
        <input type="button" className="btn-fanuc btn-fanuc--gray" 
          onClick={e => inputBack(e)} defaultValue={form_settings.form_text.back} />
        <input type="button" className="btn-fanuc btn-fanuc--yellow" 
          onClick={e => sendContact(e, token)} defaultValue={form_settings.form_text.send} />
      </div>
    </div>
  );
};

ConfirmTable.propTypes = {
  // because form dynamic change , not using shape
  form: PropTypes.object.isRequired,
  confirmDisplay: PropTypes.bool.isRequired,
  inputBack: PropTypes.func.isRequired,
  sendContact: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  // because form dynamic change , not using shape
  form_settings: PropTypes.object.isRequired
};

export default ConfirmTable;
